import Pokeball from './Pokeball.js';
import Pokedex from './Pokedex.js';
import Sprite from '../ui/Sprite.js';
import HealingItem from './HealingItem.js';
import MoveItem from './MoveItem.js';
import KeyItem from './KeyItem.js';
import HeldItem from './HeldItem.js';
import HM from './HM.js';
import Pokemon from './Pokemon.js';
import { imageStore } from '../images.js';
import ItemFactory from './ItemFactory.js';
import { getOSM, updateLoadingProgress } from '../OverworldAnimation.js';
import {
    DOWN,
    UP,
    LEFT,
    RIGHT,
    healingItemIDs,
    moveItemIDs,
    pokeballItemIDs,
    hmIds,
    heldItemIds,
    berryItemIds,
    vitaminItemIds,
    battleItemIds,
} from '../constants.js';
import { globalItemDataStore } from '../OverworldAnimation.js';

import { canvas } from '../setup.js';

export default class Player {
    constructor({
        name,
        pokemon, // All caught pokemon
        party, // Pokemon currently in party
        gender = 'boy',
    }) {
        this.id = String(Math.floor(Math.random() * 100000)).padStart(5, '0');
        this.name = name;
        this.gender = gender;
        this.pokemon = pokemon;
        this.party = party;
        this.pcPokemon = [
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
            [
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
                [null, null, null, null, null, null],
            ],
        ];
        this.items = {
            pokeballs: {
                pokeball: [],
                great_ball: [],
                ultra_ball: [],
                master_ball: [],
            },
            healingItems: {
                potion: [],
                super_potion: [],
                hyper_potion: [],
                max_potion: [],
                full_restore: [],
                revive: [],
                max_revive: [],
                antidote: [],
                burn_heal: [],
                ice_heal: [],
                awakening: [],
                paralyze_heal: [],
                full_heal: [],
                ether: [],
                max_ether: [],
                elixir: [],
                max_elixir: [],
                rare_candy: [],
            },
            hms: {
                hm1: [],
                hm2: [],
                hm3: [],
                hm4: [],
                hm5: [],
                hm6: [],
                hm7: [],
                hm8: [],
                hm9: [],
                hm10: [],
            },
            keyItems: {
                bicycle: [],
                lunchbox: [],
                town_map: [],
            },
            heldItems: {
                charcoal: [],
                mystic_water: [],
                poison_barb: [],
                miracle_seed: [],
            },
            berries: {
                cheri_berry: [],
                chesto_berry: [],
                pecha_berry: [],
                rawst_berry: [],
                aspear_berry: [],
                leppa_berry: [],
                oran_berry: [],
                persim_berry: [],
                lum_berry: [],
                sitrus_berry: [],
                berry_juice: [],
                pomeg_berry: [],
                kelpsy_berry: [],
                qualot_berry: [],
                hondew_berry: [],
                grepa_berry: [],
                tamato_berry: [],
                liechi_berry: [],
                ganlon_berry: [],
                petaya_berry: [],
                apicot_berry: [],
                salac_berry: [],
            },
            vitamins: {
                hp_up: [],
                protein: [],
                iron: [],
                calcium: [],
                zinc: [],
                carbos: [],
                pp_up: [],
                pp_max: [],
            },
            battleItems: {
                x_attack: [],
                x_defend: [],
                x_speed: [],
                x_special_attack: [],
                x_special_defense: [],
                x_accuracy: [],
                guard_spec: [],
                dire_hit: [],
            },
        };
        this.pokedex = new Pokedex({
            accessible: true,
        });
        this.money = 3000;
        this.requestedDirection = DOWN;
        this.direction = DOWN;
        this.running = false;
        this.biking = false;
        this.surfing = false;
        this.canSurf = false;
        this.steps = 0;
        this.forcedStepCount = 0;
        this.ignoreEventStepCount = 0;
        this.positionHistory = [];
        // Player Spawn Location
        // const bramblecrestTestPosition = {
        //     x: 137 * 16,
        //     y: 34 * 16,
        //     z: 0,
        // };

        const playerHousePosition = {
            x: 9 * 16,
            y: 10 * 16,
            z: 0,
        };

        this.position = playerHousePosition;
        this.displayPosition = {
            x: 112,
            y: 80,
        };

        this.displayPosition = {
            x: 112,
            y: 80,
        };

        // Girl
        const playerGirlWalkUp = imageStore.get('img/player/girl/walk/up.png');
        const playerGirlWalkLeft = imageStore.get('img/player/girl/walk/left.png');
        const playerGirlWalkDown = imageStore.get('img/player/girl/walk/down.png');
        const playerGirlWalkRight = imageStore.get('img/player/girl/walk/right.png');

        const playerGirlRunUp = imageStore.get('img/player/girl/run/up.png');
        const playerGirlRunLeft = imageStore.get('img/player/girl/run/left.png');
        const playerGirlRunRight = imageStore.get('img/player/girl/run/right.png');
        const playerGirlRunDown = imageStore.get('img/player/girl/run/down.png');

        const playerGirlBikeUp = imageStore.get('img/player/girl/bike/up.png');
        const playerGirlBikeLeft = imageStore.get('img/player/girl/bike/left.png');
        const playerGirlBikeDown = imageStore.get('img/player/girl/bike/down.png');
        const playerGirlBikeRight = imageStore.get('img/player/girl/bike/right.png');

        const playerGirlSurfUp = imageStore.get('img/player/girl/surf/up.png');
        const playerGirlSurfLeft = imageStore.get('img/player/girl/surf/left.png');
        const playerGirlSurfDown = imageStore.get('img/player/girl/surf/down.png');
        const playerGirlSurfRight = imageStore.get('img/player/girl/surf/right.png');

        // Boy
        const playerBoyWalkUp = imageStore.get('img/player/boy/walk/up.png');
        const playerBoyWalkLeft = imageStore.get('img/player/boy/walk/left.png');
        const playerBoyWalkDown = imageStore.get('img/player/boy/walk/down.png');
        const playerBoyWalkRight = imageStore.get('img/player/boy/walk/right.png');

        const playerBoyRunUp = imageStore.get('img/player/boy/run/up.png');
        const playerBoyRunLeft = imageStore.get('img/player/boy/run/left.png');
        const playerBoyRunRight = imageStore.get('img/player/boy/run/right.png');
        const playerBoyRunDown = imageStore.get('img/player/boy/run/down.png');

        const playerBoyBikeUp = imageStore.get('img/player/boy/bike/up.png');
        const playerBoyBikeLeft = imageStore.get('img/player/boy/bike/left.png');
        const playerBoyBikeDown = imageStore.get('img/player/boy/bike/down.png');
        const playerBoyBikeRight = imageStore.get('img/player/boy/bike/right.png');

        const playerBoySurfUp = imageStore.get('img/player/boy/surf/up.png');
        const playerBoySurfLeft = imageStore.get('img/player/boy/surf/left.png');
        const playerBoySurfDown = imageStore.get('img/player/boy/surf/down.png');
        const playerBoySurfRight = imageStore.get('img/player/boy/surf/right.png');

        this.overworldImages = {
            girl: {
                up: {
                    walk: playerGirlWalkUp,
                    run: playerGirlRunUp,
                    bike: playerGirlBikeUp,
                    surf: playerGirlSurfUp,
                },
                down: {
                    walk: playerGirlWalkDown,
                    run: playerGirlRunDown,
                    bike: playerGirlBikeDown,
                    surf: playerGirlSurfDown,
                },
                left: {
                    walk: playerGirlWalkLeft,
                    run: playerGirlRunLeft,
                    bike: playerGirlBikeLeft,
                    surf: playerGirlSurfLeft,
                },
                right: {
                    walk: playerGirlWalkRight,
                    run: playerGirlRunRight,
                    bike: playerGirlBikeRight,
                    surf: playerGirlSurfRight,
                },
            },
            boy: {
                up: {
                    walk: playerBoyWalkUp,
                    run: playerBoyRunUp,
                    bike: playerBoyBikeUp,
                    surf: playerBoySurfUp,
                },
                down: {
                    walk: playerBoyWalkDown,
                    run: playerBoyRunDown,
                    bike: playerBoyBikeDown,
                    surf: playerBoySurfDown,
                },
                left: {
                    walk: playerBoyWalkLeft,
                    run: playerBoyRunLeft,
                    bike: playerBoyBikeLeft,
                    surf: playerBoySurfLeft,
                },
                right: {
                    walk: playerBoyWalkRight,
                    run: playerBoyRunRight,
                    bike: playerBoyBikeRight,
                    surf: playerBoySurfRight,
                },
            },
        };

        this.overworldSprite = new Sprite({
            position: {
                x: canvas.width / 2 - 8,
                y: canvas.height / 2 - 8,
            },
            image: this.overworldImages[this.gender].down.walk,
            frames: { max: 4 },
            sprites: {
                up: this.overworldImages[this.gender].up.walk,
                left: this.overworldImages[this.gender].left.walk,
                right: this.overworldImages[this.gender].right.walk,
                down: this.overworldImages[this.gender].down.walk,
            },
            moving: false,
            hold: 16,
        });

        this.whiteoutLocation = {
            mapIdentifier: 'player_house',
            position: {
                x: this.position.x,
                y: this.position.y,
                z: this.position.z,
            },
        };
    }

    serialize(extras = {}) {
        console.log(`Serializing ${this.constructor.name}`);
        const data = {
            // Basic player data
            id: this.id,
            name: this.name,
            gender: this.gender,
            money: this.money,
            // Position and movement state
            position: this.position,
            direction: this.direction,
            requestedDirection: this.requestedDirection,
            running: this.running,
            biking: this.biking,
            surfing: this.surfing,
            canSurf: this.canSurf,
            displayPosition: this.displayPosition,
            whiteoutLocation: this.whiteoutLocation,
            steps: this.steps,
            forcedStepCount: this.forcedStepCount,
            ignoreEventStepCount: this.ignoreEventStepCount,
            positionHistory: this.positionHistory,
            // Pokemon data
            party: this.party.map((pokemon) => pokemon.serialize()),
            pokemon: this.pokemon.map((pokemon) => pokemon.serialize()),
            // // PC Pokemon - preserve the exact 3D structure with nulls
            pcPokemon: this.pcPokemon.map((box) =>
                box.map((row) => row.map((pokemon) => (pokemon ? pokemon.serialize() : null)))
            ),
            // // Pokedex
            pokedex: this.pokedex.serialize(),
            // Items as quantities
            items: {
                pokeballs: {
                    pokeball: this.items.pokeballs.pokeball.length,
                    great_ball: this.items.pokeballs.great_ball.length,
                    ultra_ball: this.items.pokeballs.ultra_ball.length,
                    master_ball: this.items.pokeballs.master_ball.length,
                },
                healingItems: {
                    potion: this.items.healingItems.potion.length,
                    super_potion: this.items.healingItems.super_potion.length,
                    hyper_potion: this.items.healingItems.hyper_potion.length,
                    max_potion: this.items.healingItems.max_potion.length,
                    full_restore: this.items.healingItems.full_restore.length,
                    revive: this.items.healingItems.revive.length,
                    max_revive: this.items.healingItems.max_revive.length,
                    antidote: this.items.healingItems.antidote.length,
                    burn_heal: this.items.healingItems.burn_heal.length,
                    ice_heal: this.items.healingItems.ice_heal.length,
                    awakening: this.items.healingItems.awakening.length,
                    paralyze_heal: this.items.healingItems.paralyze_heal.length,
                    full_heal: this.items.healingItems.full_heal.length,
                    ether: this.items.healingItems.ether.length,
                    max_ether: this.items.healingItems.max_ether.length,
                    elixir: this.items.healingItems.elixir.length,
                    max_elixir: this.items.healingItems.max_elixir.length,
                    rare_candy: this.items.healingItems.rare_candy.length,
                },
                hms: {
                    hm1: this.items.hms.hm1.length,
                    hm2: this.items.hms.hm2.length,
                    hm3: this.items.hms.hm3.length,
                    hm4: this.items.hms.hm4.length,
                    hm5: this.items.hms.hm5.length,
                    hm6: this.items.hms.hm6.length,
                    hm7: this.items.hms.hm7.length,
                    hm8: this.items.hms.hm8.length,
                    hm9: this.items.hms.hm9.length,
                    hm10: this.items.hms.hm10.length,
                },
                keyItems: {
                    bicycle: this.items.keyItems.bicycle.length,
                    lunchbox: this.items.keyItems.lunchbox.length,
                    town_map: this.items.keyItems.town_map.length,
                },
                berries: Object.fromEntries(
                    Object.keys(this.items.berries).map((id) => [id, this.items.berries[id].length])
                ),
                vitamins: Object.fromEntries(
                    Object.keys(this.items.vitamins).map((id) => [id, this.items.vitamins[id].length])
                ),
                battleItems: Object.fromEntries(
                    Object.keys(this.items.battleItems).map((id) => [id, this.items.battleItems[id].length])
                ),
            },
        };
        return { ...data, ...extras };
    }

    static async deserialize(data) {
        // Create basic player structure
        const player = new Player({
            name: data.name,
            gender: data.gender || 'girl',
            pokemon: [],
            party: [],
        });

        // Restore basic properties first
        player.id = data.id;
        player.money = data.money;
        player.position = data.position;
        player.direction = data.direction;
        player.requestedDirection = data.requestedDirection;
        player.running = data.running;
        player.biking = data.biking;
        player.surfing = data.surfing;
        player.canSurf = data.canSurf;
        player.displayPosition = data.displayPosition;
        player.whiteoutLocation = data.whiteoutLocation;
        player.steps = data.steps || 0;
        player.forcedStepCount = data.forcedStepCount || 0;
        player.ignoreEventStepCount = data.ignoreEventStepCount || 0;
        player.positionHistory = data.positionHistory || [];
        // Deserialize Pokemon without trainer references resolved yet
        player.pokemon = await Promise.all(
            data.pokemon.map((pokemonData) => Pokemon.deserialize(pokemonData))
        );

        player.party = await Promise.all(data.party.map((pokemonData) => Pokemon.deserialize(pokemonData)));

        // Deserialize PC Pokemon
        player.pcPokemon = await Promise.all(
            data.pcPokemon.map(
                async (box) =>
                    await Promise.all(
                        box.map(
                            async (row) =>
                                await Promise.all(
                                    row.map(async (pokemonData) =>
                                        pokemonData ? await Pokemon.deserialize(pokemonData) : null
                                    )
                                )
                        )
                    )
            )
        );

        // Now resolve trainer references for all Pokemon
        const allPokemon = [
            ...player.pokemon,
            ...player.party,
            ...player.pcPokemon.flat(2).filter((p) => p !== null),
        ];

        allPokemon.forEach((pokemon) => {
            // Resolve original trainer
            if (pokemon._originalTrainerId === player.id) {
                pokemon.originalTrainer = player;
            }
            // Resolve current trainer
            if (pokemon._currentTrainerId === player.id) {
                pokemon.currentTrainer = player;
            }

            // Clean up temporary ID properties
            delete pokemon._originalTrainerId;
            delete pokemon._currentTrainerId;
        });

        // Deserialize Pokedex
        player.pokedex = Pokedex.deserialize(data.pokedex);

        // Recreate items from quantities
        const itemCategories = [
            { category: 'pokeballs', items: data.items.pokeballs },
            { category: 'healingItems', items: data.items.healingItems },
            { category: 'hms', items: data.items.hms },
            { category: 'keyItems', items: data.items.keyItems },
            { category: 'berries', items: data.items.berries || {} },
            { category: 'vitamins', items: data.items.vitamins || {} },
            { category: 'battleItems', items: data.items.battleItems || {} },
        ];

        itemCategories.forEach(({ category, items }) => {
            if (!player.items[category]) return;
            Object.entries(items || {}).forEach(([itemId, quantity]) => {
                if (!player.items[category][itemId]) return;
                for (let i = 0; i < quantity; i++) {
                    const item = ItemFactory.create(itemId);
                    player.items[category][itemId].push(item);
                }
            });
        });

        // Back-fill the Town Map for pre-existing saves. Without this, players
        // who started a file before the Town Map shipped would never see the
        // item without creating a brand new save.
        if (player.items.keyItems.town_map.length === 0) {
            player.items.keyItems.town_map.push(ItemFactory.create('town_map'));
        }

        if (data.options) {
            player._savedOptions = data.options;
        }

        return player;
    }

    getGender() {
        return this.gender;
    }

    facingDown() {
        return this.direction === DOWN;
    }
    facingUp() {
        return this.direction === UP;
    }
    facingLeft() {
        return this.direction === LEFT;
    }
    facingRight() {
        return this.direction === RIGHT;
    }

    acquirePokemon(p) {
        p.originalTrainer = this;
        p.currentTrainer = this;
        this.pokemon.push(p);
        if (this.party.length >= 6) {
            this.addPokemonToPC(p);
        } else {
            this.addPokemonToParty(p);
        }
        this.pokedex.addSeenPokemon(p);
        this.pokedex.addCaughtPokemon(p);
    }

    addPokemonToPC(newPokemon) {
        const findFirstNull = (list) => {
            // Iterate through each box
            for (let boxIndex = 0; boxIndex < list.length; boxIndex++) {
                const box = list[boxIndex];

                // Iterate through each row in the box
                for (let rowIndex = 0; rowIndex < box.length; rowIndex++) {
                    const row = box[rowIndex];

                    // Iterate through each column in the row
                    for (let columnIndex = 0; columnIndex < row.length; columnIndex++) {
                        // Check if the value is null
                        if (row[columnIndex] === null) {
                            // Return the position as soon as we find a null
                            return {
                                box: boxIndex,
                                row: rowIndex,
                                column: columnIndex,
                            };
                        }
                    }
                }
            }
        };
        const emptySlot = findFirstNull(this.pcPokemon);
        this.pcPokemon[emptySlot.box][emptySlot.row][emptySlot.column] = newPokemon;
        return;
    }

    step() {
        if (this.positionHistory.length === 0) {
            this.positionHistory.push({
                x: this.position.x,
                y: this.position.y,
                z: this.position.z,
            });
            this.steps += 1;
            this.forcedStepCount = Math.max(this.forcedStepCount - 1, 0);
            this.ignoreEventStepCount = Math.max(this.ignoreEventStepCount - 1, 0);
            return;
        }

        if (
            this.position.x === this.positionHistory[0].x &&
            this.position.y === this.positionHistory[0].y &&
            this.position.z === this.positionHistory[0].z
        ) {
            return;
        }

        this.positionHistory.unshift({
            x: this.position.x,
            y: this.position.y,
            z: this.position.z,
        });
        this.steps += 1;
        this.forcedStepCount = Math.max(this.forcedStepCount - 1, 0);
        this.ignoreEventStepCount = Math.max(this.ignoreEventStepCount - 1, 0);
        if (this.positionHistory.length >= 10) {
            this.positionHistory.pop();
        }
    }

    addPokemonToParty(p) {
        if (this.party.length < 6) {
            this.party.push(p);
            return true;
        }
        return false;
    }

    seePokemon(p) {
        if (!this.pokedex.seen.includes(p.id)) {
            this.pokedex.seen.push(p.id);
        }
    }

    whitedOut() {
        return !this.party.some((p) => p.stats.hp > 0);
    }

    resetToWhiteoutLocation() {
        this.position = {
            x: this.whiteoutLocation.position.x,
            y: this.whiteoutLocation.position.y,
            z: this.whiteoutLocation.position.z,
        };
        this.direction = DOWN;
    }

    acquireItem(item) {
        if (item instanceof HealingItem || item instanceof MoveItem) {
            this.items.healingItems[item.id].push(item);
        } else if (item instanceof Pokeball) {
            this.items.pokeballs[item.id].push(item);
        } else if (item instanceof HM) {
            this.items.hms[item.id].push(item);
        } else if (item instanceof KeyItem) {
            this.items.keyItems[item.id].push(item);
        } else if (item instanceof HeldItem) {
            this.items.heldItems[item.id].push(item);
        } else if (berryItemIds.includes(item.id) && this.items.berries[item.id]) {
            this.items.berries[item.id].push(item);
        } else if (vitaminItemIds.includes(item.id) && this.items.vitamins[item.id]) {
            this.items.vitamins[item.id].push(item);
        } else if (battleItemIds.includes(item.id) && this.items.battleItems[item.id]) {
            this.items.battleItems[item.id].push(item);
        }
    }

    itemCount(id) {
        if ([...healingItemIDs, ...moveItemIDs].includes(id)) {
            return this.items.healingItems[id].length;
        } else if (pokeballItemIDs.includes(id)) {
            return this.items.pokeballs[id].length;
        } else if (hmIds.includes(id)) {
            return this.items.hms[id].length;
        }
    }

    acquireItemFromId(itemId) {
        const newItem = ItemFactory.create(itemId);
        this.acquireItem(newItem);
        return newItem;
    }

    useItem(item) {
        if (item instanceof HealingItem) {
            this.items.healingItems[item.id].pop();
        } else if (item instanceof Pokeball) {
            this.items.pokeballs[item.id].pop();
        }
    }

    useItemV2(itemId) {
        if (Object.keys(this.items.healingItems).includes(itemId)) {
            this.items.healingItems[itemId].pop();
        } else if (Object.keys(this.items.pokeballs).includes(itemId)) {
            this.items.pokeballs[itemId].pop();
        } else if (Object.keys(this.items.heldItems).includes(itemId)) {
            this.items.heldItems[itemId].pop();
        } else if (Object.keys(this.items.berries).includes(itemId)) {
            this.items.berries[itemId].pop();
        } else if (Object.keys(this.items.vitamins).includes(itemId) && this.items.vitamins[itemId]?.length) {
            this.items.vitamins[itemId].pop();
        } else if (Object.keys(this.items.battleItems).includes(itemId) && this.items.battleItems[itemId]?.length) {
            this.items.battleItems[itemId].pop();
        }
    }

    healParty() {
        this.party.forEach((pokemon) => pokemon.heal());
    }

    pokeballsList() {
        return [
            {
                id: 'pokeball',
                name: 'Pokeball',
                quantity: this.items.pokeballs.pokeball.length,
                imageSource: `pokeball.png`,
            },
            {
                id: 'great_ball',
                name: 'Great Ball',
                quantity: this.items.pokeballs.great_ball.length,
                imageSource: 'great_ball.png',
            },
            {
                id: 'ultra_ball',
                name: 'Ultra Ball',
                quantity: this.items.pokeballs.ultra_ball.length,
                imageSource: 'ultra_ball.png',
            },
            {
                id: 'master_ball',
                name: 'Master Ball',
                quantity: this.items.pokeballs.master_ball.length,
                imageSource: 'master_ball.png',
            },
        ].filter((ball) => ball.quantity > 0);
    }

    hmsList() {
        return [
            {
                id: 'hm1',
                name: 'HM01 - Cut',
                quantity: this.items.hms.hm1.length,
                imageSource: null,
            },
            {
                id: 'hm2',
                name: 'HM02 - Fly',
                quantity: this.items.hms.hm2.length,
                imageSource: null,
            },
            {
                id: 'hm3',
                name: 'HM03 - Surf',
                quantity: this.items.hms.hm3.length,
                imageSource: null,
            },
            {
                id: 'hm4',
                name: 'HM04 - Rock Smash',
                quantity: this.items.hms.hm4.length,
                imageSource: null,
            },
            {
                id: 'hm5',
                name: 'HM05 - Flash',
                quantity: this.items.hms.hm5.length,
                imageSource: null,
            },
            {
                id: 'hm6',
                name: 'HM06 - Strength',
                quantity: this.items.hms.hm6.length,
                imageSource: null,
            },
        ].filter((hm) => hm.quantity > 0);
    }

    keyItemsList() {
        return [
            {
                id: 'bicycle',
                name: 'Bicycle',
                quantity: this.items.keyItems.bicycle.length,
                imageSource: 'bicycle.png',
            },
            {
                id: 'lunchbox',
                name: 'Lunch Box',
                quantity: this.items.keyItems.lunchbox.length,
                imageSource: 'lunchbox.png',
            },
            {
                id: 'town_map',
                name: 'Town Map',
                quantity: this.items.keyItems.town_map.length,
                imageSource: 'town_map.png',
            },
        ].filter((keyItem) => keyItem.quantity > 0);
    }

    hasCut() {
        return this.hmsList().filter((hm) => hm.id === 'hm1' && hm.quantity > 0);
    }

    hasRockSmash() {
        return this.hmsList().filter((hm) => hm.id === 'hm4' && hm.quantity > 0);
    }

    hasFlash() {
        return (
            this.hmsList().filter((hm) => {
                return hm.id === 'hm5' && hm.quantity > 0;
            }).length > 0
        );
    }

    hasSurf() {
        return (
            this.hmsList().filter((hm) => {
                return hm.id === 'hm3' && hm.quantity > 0;
            }).length > 0
        );
    }

    heldItemsList() {
        return [
            {
                id: 'charcoal',
                name: 'Charcoal',
                quantity: this.items.heldItems.charcoal.length,
                imageSource: 'charcoal.png',
            },
            {
                id: 'miracle_seed',
                name: 'Miracle Seed',
                quantity: this.items.heldItems.miracle_seed.length,
                imageSource: 'miracle_seed.png',
            },
            {
                id: 'mystic_water',
                name: 'Mystic Water',
                quantity: this.items.heldItems.mystic_water.length,
                imageSource: 'mystic_water.png',
            },
            {
                id: 'poison_barb',
                name: 'Poison Barb',
                quantity: this.items.heldItems.poison_barb.length,
                imageSource: 'poison_barb.png',
            },
        ].filter((item) => item.quantity > 0);
    }

    berriesList() {
        return Object.keys(this.items.berries)
            .filter((id) => this.items.berries[id].length > 0)
            .map((id) => ({
                id,
                name: globalItemDataStore[id]?.name ?? id,
                quantity: this.items.berries[id].length,
                imageSource: `${id}.png`,
            }));
    }

    vitaminsList() {
        const list = Object.keys(this.items.vitamins)
            .filter((id) => this.items.vitamins[id].length > 0)
            .map((id) => ({
                id,
                name: globalItemDataStore[id]?.name ?? id,
                quantity: this.items.vitamins[id].length,
                imageSource: `${id}.png`,
            }));
        const rareCandyQty = this.items.healingItems.rare_candy?.length ?? 0;
        if (rareCandyQty > 0) {
            list.push({
                id: 'rare_candy',
                name: globalItemDataStore.rare_candy?.name ?? 'Rare Candy',
                quantity: rareCandyQty,
                imageSource: 'rare_candy.png',
            });
        }
        return list;
    }

    battleItemsList() {
        return Object.keys(this.items.battleItems)
            .filter((id) => this.items.battleItems[id].length > 0)
            .map((id) => ({
                id,
                name: globalItemDataStore[id]?.name ?? id,
                quantity: this.items.battleItems[id].length,
                imageSource: `${id}.png`,
            }));
    }

    healingItemsList() {
        const all = [
            {
                id: 'potion',
                name: 'Potion',
                quantity: this.items.healingItems.potion.length,
                imageSource: 'potion.png',
            },
            {
                id: 'super_potion',
                name: 'Super Potion',
                quantity: this.items.healingItems.super_potion.length,
            },
            {
                id: 'hyper_potion',
                name: 'Hyper Potion',
                quantity: this.items.healingItems.hyper_potion.length,
            },
            {
                id: 'max_potion',
                name: 'Max Potion',
                quantity: this.items.healingItems.max_potion.length,
            },
            {
                id: 'full_restore',
                name: 'Full Restore',
                quantity: this.items.healingItems.full_restore.length,
            },
            {
                id: 'revive',
                name: 'Revive',
                quantity: this.items.healingItems.revive.length,
            },
            {
                id: 'max_revive',
                name: 'Max Revive',
                quantity: this.items.healingItems.max_revive.length,
            },
            {
                id: 'antidote',
                name: 'Antidote',
                quantity: this.items.healingItems.antidote.length,
            },
            {
                id: 'burn_heal',
                name: 'Burn Heal',
                quantity: this.items.healingItems.burn_heal.length,
            },
            {
                id: 'ice_heal',
                name: 'Ice Heal',
                quantity: this.items.healingItems.ice_heal.length,
            },
            {
                id: 'awakening',
                name: 'Awakening',
                quantity: this.items.healingItems.awakening.length,
            },
            {
                id: 'paralyze_heal',
                name: 'Paralyze Heal',
                quantity: this.items.healingItems.paralyze_heal.length,
            },
            {
                id: 'full_heal',
                name: 'Full Heal',
                quantity: this.items.healingItems.full_heal.length,
            },
            {
                id: 'ether',
                name: 'Ether',
                quantity: this.items.healingItems.ether.length,
            },
            {
                id: 'max_ether',
                name: 'Max Ether',
                quantity: this.items.healingItems.max_ether.length,
            },
            {
                id: 'elixir',
                name: 'Elixir',
                quantity: this.items.healingItems.elixir.length,
            },
            {
                id: 'max_elixir',
                name: 'Max Elixir',
                quantity: this.items.healingItems.max_elixir.length,
            },
            {
                id: 'rare_candy',
                name: 'Rare Candy',
                quantity: this.items.healingItems.rare_candy.length,
            },
        ];
        return all.filter((item) => item.quantity > 0 && item.id !== 'rare_candy');
    }

    getAvailableItems() {
        return [
            this.healingItemsList(),
            this.berriesList(),
            this.vitaminsList(),
            this.heldItemsList(),
            this.pokeballsList(),
            this.hmsList(),
            this.keyItemsList(),
            this.battleItemsList(),
        ];
    }

    isPartyHealed() {
        return this.party.length === 0 || this.party.every((pokemon) => pokemon.isHealed());
    }

    updateOverworldSprite() {
        if (this.running && !this.surfing) {
            this.overworldSprite.width = 16;
            this.overworldSprite.height = 24;
            this.overworldSprite.position.x = canvas.width / 2 - 8;
            this.overworldSprite.position.y = canvas.height / 2 - 8;
            this.overworldSprite.hold = 8;
            this.overworldSprite.frames.max = 4;
            if (this.direction === DOWN) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].down.run);
            }
            if (this.direction === LEFT) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].left.run);
            }
            if (this.direction === RIGHT) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].right.run);
            }
            if (this.direction === UP) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].up.run);
            }
        } else if (this.biking) {
            if (this.direction === DOWN) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].down.bike);
            }
            if (this.direction === LEFT) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].left.bike);
            }
            if (this.direction === RIGHT) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].right.bike);
            }
            if (this.direction === UP) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].up.bike);
            }
            this.overworldSprite.position.x = canvas.width / 2 - 16;
            this.overworldSprite.position.y = canvas.height / 2 - 16;
            this.overworldSprite.width = 32;
            this.overworldSprite.height = 32;
            this.overworldSprite.hold = 8;
            this.overworldSprite.frames.max = 4;
        } else if (this.surfing && !this.overworldSprite.jumping) {
            if (this.direction === DOWN) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].down.surf);
            }
            if (this.direction === LEFT) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].left.surf);
            }
            if (this.direction === RIGHT) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].right.surf);
            }
            if (this.direction === UP) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].up.surf);
            }
            this.overworldSprite.position.x = canvas.width / 2 - 16;
            this.overworldSprite.position.y = canvas.height / 2 - 16;
            this.overworldSprite.width = 32;
            this.overworldSprite.height = 32;
            this.overworldSprite.hold = 64;
            this.overworldSprite.frames.max = 4;
            this.overworldSprite.moving = true;
        } else {
            this.overworldSprite.width = 16;
            this.overworldSprite.height = 24;
            this.overworldSprite.position.x = canvas.width / 2 - 8;
            this.overworldSprite.position.y = canvas.height / 2 - 8;
            this.overworldSprite.hold = 16;
            this.overworldSprite.frames.max = 4;
            if (this.direction === DOWN) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].down.walk);
            }
            if (this.direction === LEFT) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].left.walk);
            }
            if (this.direction === RIGHT) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].right.walk);
            }
            if (this.direction === UP) {
                this.overworldSprite.setImage(this.overworldImages[this.gender].up.walk);
            }
        }
    }

    getNearestNPC() {
        const npcs = getOSM().currentMap.npcs;

        // Filter NPCs on the same plane, then sort by distance
        const samePlaneNPCs = npcs.filter((npc) => npc.position.z === this.position.z);

        samePlaneNPCs.sort((a, b) => {
            // Calculate 2D distance from player to each NPC
            const distanceA = Math.sqrt(
                Math.pow(a.position.x - this.position.x, 2) + Math.pow(a.position.y - this.position.y, 2)
            );
            const distanceB = Math.sqrt(
                Math.pow(b.position.x - this.position.x, 2) + Math.pow(b.position.y - this.position.y, 2)
            );

            return distanceA - distanceB; // Ascending order (closest first)
        });

        return samePlaneNPCs[0] || null; // Return closest NPC or null if none found
    }

    moveSteps(steps) {
        if (this.direction === DOWN) {
            this.targetPosition = {
                x: this.position.x,
                y: this.position.y + steps * 16,
                z: this.position.z,
            };
        }
        if (this.direction === UP) {
            this.targetPosition = {
                x: this.position.x,
                y: this.position.y - steps * 16,
                z: this.position.z,
            };
        }
        if (this.direction === LEFT) {
            this.targetPosition = {
                x: this.position.x - steps * 16,
                y: this.position.y,
                z: this.position.z,
            };
        }
        if (this.direction === RIGHT) {
            this.targetPosition = {
                x: this.position.x + steps * 16,
                y: this.position.y,
                z: this.position.z,
            };
        }
    }
}

class PlayerManager {
    constructor() {}

    async loadPlayerData() {
        const testPlayer = new Player({
            name: 'Lucy',
            party: [],
            pokemon: [],
        });

        // testPlayer.acquirePokemon(nidoranM);
        // testPlayer.acquirePokemon(treecko);
        // test pokemon
        // const nidoranM = await Pokemon.create({
        //     id: 190,
        //     level: 8,
        //     iv: {
        //         hp: 31,
        //         attack: 31,
        //         defense: 31,
        //         specialAttack: 31,
        //         specialDefense: 31,
        //         speed: 31,
        //     },
        // });

        // const poke2 = await Pokemon.create({
        //     id: 67,
        //     level: 8,
        //     iv: {
        //         hp: 31,
        //         attack: 31,
        //         defense: 31,
        //         specialAttack: 31,
        //         specialDefense: 31,
        //         speed: 31,
        //     },
        // });

        // // nidoranM.stats.hp = 1; // test
        // nidoranM.moves[0] = getMove('whirlwind');
        // nidoranM.moves[1] = getMove('scratch');
        // nidoranM.moves[2] = getMove('ingrain');
        // nidoranM.moves[3] = getMove('leech_seed');
        // poke2.moves[0] = getMove('whirlwind');
        // poke2.moves[1] = getMove('roar');
        // poke2.moves[2] = getMove('confuse_ray');
        // poke2.moves[3] = getMove('leech_seed');
        // const poisonStatus = new Status({
        //     id: 'poison',
        //     startTurn: 0,
        //     duration: 3,
        //     pokemon: nidoranM,
        // });
        // nidoranM.status1 = poisonStatus;
        // nidoranM.volatileStatuses.rooted = 10;

        // testPlayer.acquirePokemon(nidoranM);
        // testPlayer.acquirePokemon(poke2);

        await new Promise((resolve) => setTimeout(resolve, 100));

        updateLoadingProgress('ADDING_ITEMS', 'Adding items...');
        // Create and add items in parallel

        const pokeballs = [];
        for (let i = 0; i < 100; i++) {
            pokeballs.push(new Pokeball({ id: `pokeball`, name: 'Pokeball', catchRate: 1 }));
            pokeballs.push(new Pokeball({ id: `great_ball`, name: 'Great Ball', catchRate: 1 }));
            pokeballs.push(new Pokeball({ id: `ultra_ball`, name: 'Ultra Ball', catchRate: 1 }));
            pokeballs.push(new Pokeball({ id: `master_ball`, name: 'Master Ball', catchRate: 1 }));
        }

        const potions = [];
        for (let i = 0; i < 10; i++) {
            potions.push(new HealingItem({ id: 'potion', name: 'Potion', healAmount: 20 }));
            potions.push(new HealingItem({ id: 'super_potion', name: 'Super Potion', healAmount: 50 }));
            potions.push(new HealingItem({ id: 'hyper_potion', name: 'Hyper Potion', healAmount: 200 }));
            potions.push(new HealingItem({ id: 'max_potion', name: 'Max Potion', healAmount: 999 }));
            potions.push(new HealingItem({ id: 'full_restore', name: 'Full Restore', healAmount: 999 }));
            potions.push(new HealingItem({ id: 'revive', name: 'Revive', healAmount: 50 }));
            potions.push(new HealingItem({ id: 'max_revive', name: 'Max Revive', healAmount: 999 }));
            potions.push(new HealingItem({ id: 'antidote', name: 'Antidote', healAmount: 0 }));
            potions.push(new HealingItem({ id: 'burn_heal', name: 'Burn Heal', healAmount: 0 }));
            potions.push(new HealingItem({ id: 'ice_heal', name: 'Ice Heal', healAmount: 0 }));
            potions.push(new HealingItem({ id: 'awakening', name: 'Awakening', healAmount: 0 }));
            potions.push(new HealingItem({ id: 'paralyze_heal', name: 'Paralyze Heal', healAmount: 0 }));
            potions.push(new HealingItem({ id: 'full_heal', name: 'Full Heal', healAmount: 0 }));
            potions.push(new HealingItem({ id: 'ether', name: 'Ether', healAmount: 10 }));
            potions.push(new HealingItem({ id: 'max_ether', name: 'Max Ether', healAmount: 999 }));
            potions.push(new HealingItem({ id: 'elixir', name: 'Elixir', healAmount: 10 }));
            potions.push(new HealingItem({ id: 'max_elixir', name: 'Max Elixir', healAmount: 999 }));
            potions.push(new HealingItem({ id: 'rare_candy', name: 'Rare Candy', healAmount: 0 }));
        }

        const items = [
            new KeyItem({ id: 'bicycle' }),
            new KeyItem({ id: 'town_map' }),
            ...Array.from({ length: 10 }, (_, i) => new HM({ id: `hm${i + 1}` })),
            ...pokeballs,
            ...potions,
        ];

        // const simpleItems = [
        //     new HealingItem({ id: 'potion', name: 'Potion', healAmount: 20 }),
        //     new HealingItem({ id: 'potion', name: 'Potion', healAmount: 20 }),
        //     new Pokeball({ id: 'pokeball', name: 'Pokeball', catchRate: 255 }),
        //     new Pokeball({ id: 'pokeball', name: 'Pokeball', catchRate: 255 }),
        //     new Pokeball({ id: 'pokeball', name: 'Pokeball', catchRate: 255 }),
        //     new Pokeball({ id: 'pokeball', name: 'Pokeball', catchRate: 255 }),
        //     new Pokeball({ id: 'pokeball', name: 'Pokeball', catchRate: 255 }),
        //     new Pokeball({ id: 'great_ball', name: 'Pokeball', catchRate: 255 }),
        //     new Pokeball({ id: 'great_ball', name: 'Pokeball', catchRate: 255 }),
        //     new Pokeball({ id: 'great_ball', name: 'Pokeball', catchRate: 255 }),
        // ];

        // const noItems = [];

        items.forEach((item) => {
            testPlayer.acquireItem(item);
        });

        // Seed berries and vitamins (usage not implemented yet)
        const berrySeeds = [
            { id: 'oran_berry', count: 5 },
            { id: 'sitrus_berry', count: 3 },
            { id: 'lum_berry', count: 2 },
            { id: 'leppa_berry', count: 3 },
            { id: 'cheri_berry', count: 2 },
            { id: 'berry_juice', count: 1 },
        ];
        const vitaminSeeds = [
            { id: 'protein', count: 2 },
            { id: 'iron', count: 1 },
            { id: 'pp_up', count: 2 },
            { id: 'pp_max', count: 2 },
            { id: 'rare_candy', count: 1 },
        ];
        berrySeeds.forEach(({ id, count }) => {
            for (let i = 0; i < count; i++) testPlayer.acquireItemFromId(id);
        });
        vitaminSeeds.forEach(({ id, count }) => {
            for (let i = 0; i < count; i++) testPlayer.acquireItemFromId(id);
        });

        const battleItemSeeds = [
            { id: 'x_attack', count: 5 },
            { id: 'x_defend', count: 5 },
            { id: 'x_speed', count: 5 },
            { id: 'x_special_attack', count: 5 },
            { id: 'x_special_defense', count: 5 },
            { id: 'x_accuracy', count: 5 },
            { id: 'guard_spec', count: 3 },
            { id: 'dire_hit', count: 3 },
        ];
        battleItemSeeds.forEach(({ id, count }) => {
            for (let i = 0; i < count; i++) testPlayer.acquireItemFromId(id);
        });

        await new Promise((resolve) => setTimeout(resolve, 100));
        return testPlayer;
    }
}

export const playerManager = new PlayerManager();
